<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'

export default
{
    mixins: [ adminTable ],

    computed:
    {
        fullUrl()
        {
            return `${process.env.API_URL}${this.url}/table`
        }
    },

    methods:
    {
        newPost()
        {
            this.$router.push('/news/create')
        },

        editPost(post)
        {
            this.$router.push(`/news/edit/${post.id}`)
        },
    },

    data()
    {
        return {
            noFetch: true,
            data: [],
            url: '/v1/admin/posts',
            tableName: 'tableNews',
            emptyModel: { title: null, excerpt: null, content: null, attachments: [], videos: [], is_media: false, type: 'news', slug: null, pinned: false, cover_id: null },
            columns: [ 'id', 'picture', 'title', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    title: this.$t('POST.TITLE'),
                    picture: this.$t('GENERAL.IMAGE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 10,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['title', 'created_at', 'updated_at'],
                sortable: ['id', 'updated_at', 'title'],
                responseAdapter: res => {
                    return res && res.data ? {
                      data: res.data.data,
                      count: res.data.count,
                    } : { data: [], count: 0}
                },
                params: {
                  type: 'news',
                },
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.POSTS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newPost">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-server-table :url="fullUrl" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button v-if="props.row.is_published" class="btn btn-xs btn-warning" @click="unpublish(props.row)">
                            <icon name="eye-slash"></icon>
                        </button>
                        <button v-if="!props.row.is_published" class="btn btn-xs btn-primary" @click="publish(props.row)">
                            <icon name="eye"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="editPost(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="picture" slot-scope="props">
                        <div class="text-center" v-if="(props.row.attachments && props.row.attachments.length > 0) || (props.row.cover && props.row.cover.id )">
                            <img :src="props.row.cover.thumbnail_url" v-if="props.row.cover && props.row.cover.id">
                            <img :src="props.row.attachments[0].thumbnail_url" v-else-if="props.row.attachments && props.row.attachments.length > 0">
                        </div>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <strong>
                                    {{ $t('POST.CONTENT')}}
                                </strong>
                            </div>
                            <div class="panel-body">
                                <div v-html="props.row.content">
                                </div>
                            </div>
                        </div>
                    </div>
                </v-server-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/News.vue